angular
  .module('countriesApp')
  .controller('ListController', [
    '$rootScope',
    '$scope',
    'CountryService',
    function (
      $rootScope,
      $scope,
      Country
    ) {
      $rootScope.$emit('updateTitle');

      /**
       * CONTROLLER VARIABLES
       */
      $scope.countries = null;

      /**
       * CONTROLLER FUNCTIONS
       */
      /**
       * Gets all the countries from the Back-End and stores the ones with the page enabled in the
       * controller
       *
       * @returns {undefined}
       */
      const init = () => {
        Country.getAll()
          .then(countries => {
            $scope.countries = countries.filter(country => country.has_page);
          });
      };

      /**
       * DATA OBTAINING
       */
      init();
    }
  ]);
